export const simpleComparisonToStringMap = {
    GREATER_OR_EQUAL: "Supérieur ou égal",
    LESS: "Inférieur",
}

export const comparisonToStringMap = {
    GREATER_OR_EQUAL: "Supérieur ou égal",
    GREATER: "Supérieur",
    EQUAL: "Égal",
    LESS_OR_EQUAL: "Inférieur ou égal",
    LESS: "Inférieur",
    MAX: "Max",
    MIN: "Min",
    MANDATORY: "Obligatoire",
}

export const risksMap = {
    1: "Modéré",
    2: "Fort",
}